webpackJsonp([219934954866362],{

/***/ 1087:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Label","methods":[],"props":{"content":{"type":{"name":"string"},"required":false,"description":"Content of label.","defaultValue":{"value":"''","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"CSS Class to apply to label.","defaultValue":{"value":"''","computed":false}},"style":{"type":{"name":"objectOf","value":{"name":"any"}},"required":false,"description":"Css style applied to the component","defaultValue":{"value":"null","computed":false}},"htmlFor":{"type":{"name":"string"},"required":false,"description":"Id of input.","defaultValue":{"value":"''","computed":false}}},"filename":"/components/Label/Label.jsx"}

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _label = __webpack_require__(518);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _map = __webpack_require__(1087);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _label2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _label2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Label',
	        description: _label2.default.summary,
	        stories: _label2.default.stories,
	        importCode: _label2.default.import,
	        withStyles: _label2.default.withStyles,
	        extractProps: _label2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'Input',
	  summary: 'The Label defines a label for an Input element. The Label element does not render as anything special for the user. However, it provides a usability improvement for mouse users, because if the user clicks on the text within the Label element, it toggles the control. The for attribute of the Label should be equal to the id attribute of the related element to bind them together.',
	  import: '',
	  withStyles: true,
	  stories: [{
	    name: 'Basic',
	    summary: '',
	    code: '<Label content="This is a label" />',
	    tabsActive: ['code']
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-label-js-2a47ce9e8619f0db102e.js